<template>
  <CModal
    size="lg"
    centered
    :closeOnBackdrop="false"
    :show.sync="modalVisible"
    addContentClasses="border-0 modal-border-radius"
  >
    <div slot="header" />
    <div slot="header-wrapper" />
    <div slot="body-wrapper">
      <closeButton :setModalVisible="setModalVisible" />
      <CContainer style="padding: 3.125rem 7.8125rem">
        <div class=containerModal>
          <CRow v-for="(item, index) in topic" :key="index" style="margin-bottom: 15px">
          <CCol col="4" style="text-align:center">
            <p class="mb-0" style="font-size: 12px;">TEST : </p>
            <h4>{{ item.name }}</h4>
          </CCol>
          <CCol col="4" style="text-align:center">
            <p class="mb-0" style="font-size: 12px;">OLD STATUS : </p>
            <h4 v-if="item.status" style="color:green">ON</h4>
            <h4 v-else style="color:red">OFF</h4>
          </CCol>
          <CCol col="4" style="text-align:center">
            <p class="mb-0" style="font-size: 12px;">NEW STATUS : </p>
            <h4 v-if="item.status" style="color:red">OFF</h4>
            <h4 v-else style="color:green">ON</h4>
          </CCol>
        </CRow>
        </div>
        
        <CRow class="modal-title mb-4 mt-4">
          <CCol col="12" style="text-align:center;">
            <h4>Are you sure you want to change the test status?</h4>
            <!-- <div class="modal-title">{{topic || 'Selected topic'}}</div> -->
          </CCol>
        </CRow>

        <!-- <CRow alignHorizontal="between" class="modal-detail">
          <CCol>
            <div class="input-label pink">Start Date</div>
            <input type="date" class="input input-date" />
          </CCol>
          <CCol>
            <div class="input-label green">End Date</div>
            <input type="date" class="input input-date" />
          </CCol>
        </CRow>
        <CRow alignHorizontal="between" class="modal-detail">
          <CCol>
            <div class="input-label pink">Start Time</div>
            <input type="time" class="input input-date" />
          </CCol>
          <CCol>
            <div class="input-label green">End Time</div>
            <input type="time" class="input input-date" />
          </CCol>
        </CRow> -->
        <CRow alignHorizontal="center">
          <CCol col="6">
            <div
              @click="setModalVisible()"
              class="button button-pink"
              style="margin-right: 0.9375rem"
            >
              CANCEL
            </div>
          </CCol>
          <CCol col="6">
            <div
              class="button button-green"
              style="margin-right: 0.9375rem"
              @click="onClick()"
            >
              CONFIRM
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
    <div slot="footer" />
    <div slot="footer-wrapper" />
  </CModal>
</template>

<script>
import closeButton from "./closeButton";
export default {
  name: "ScheduleExam",
  props: {
    modalVisible: Boolean,
    setModalVisible: Function,
    topic: Array,
  },
  components: {
    closeButton,
  },
  watch: {
    topic(val) {
    },
  },
  methods: {
    onClick() {
      this.$emit("returnChangeManyQuizStatus", true);
    },
  },
};
</script>

<style>
.containerModal{
  border: 1px solid black;
  border-radius: 10px;
  padding: 20px;
}
</style>